import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73783d47"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "create-score-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "摩点官方抽奖提报", -1));
const _hoisted_3 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "top_tips"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本活动支持多次提报", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择优惠类型", -1));
const _hoisted_8 = {
  class: "type_item"
};
const _hoisted_9 = {
  class: "tips"
};
const _hoisted_10 = {
  key: 0,
  class: "empty_box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无回报档", -1));
const _hoisted_13 = {
  key: 1,
  class: "score_list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "score_items"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择项目", -1));
const _hoisted_18 = {
  class: "with-arrow"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择回报档", -1));
const _hoisted_21 = {
  class: "with-arrow"
};
const _hoisted_22 = {
  class: "score_item"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "原价", -1));
const _hoisted_24 = {
  key: 0,
  class: "score_item"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "折扣（折）", -1));
const _hoisted_26 = {
  class: "score_input_wrapper"
};
const _hoisted_27 = {
  class: "score_item"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动价格", -1));
const _hoisted_29 = {
  class: "activity_price"
};
const _hoisted_30 = {
  class: "score_item"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动库存", -1));
const _hoisted_32 = {
  class: "score_input_wrapper"
};
const _hoisted_33 = {
  key: 0,
  class: "stock-hint"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开奖时间", -1));
const _hoisted_36 = {
  class: "time"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开奖时间", -1));
const _hoisted_39 = {
  class: "time"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  key: 1
};
const _hoisted_42 = {
  key: 2,
  class: "tips"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "自定义开奖时间", -1));
const _hoisted_45 = {
  class: "time"
};
const _hoisted_46 = {
  key: 2,
  class: "bottom_tips"
};
const _hoisted_47 = {
  key: 3,
  class: "bottom_btn"
};
const _hoisted_48 = {
  key: 0,
  class: "share-modal"
};
const _hoisted_49 = {
  class: "share-modal-content"
};
const _hoisted_50 = {
  class: "share-modal-title"
};
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 选择玩法 ");
const _hoisted_52 = {
  class: "share_reward_content"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  class: "name"
};
const _hoisted_55 = {
  class: "tips"
};
const _hoisted_56 = {
  key: 1,
  class: "share-modal"
};
const _hoisted_57 = {
  class: "share-modal-content"
};
const _hoisted_58 = {
  class: "share-modal-title"
};
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 选择项目 ");
const _hoisted_60 = {
  class: "pro-select-content"
};
const _hoisted_61 = /*#__PURE__*/_createTextVNode("加载中...");
const _hoisted_62 = ["onClick"];
const _hoisted_63 = {
  class: "pro_info"
};
const _hoisted_64 = ["src"];
const _hoisted_65 = {
  class: "pro_name"
};
const _hoisted_66 = {
  key: 0,
  class: "empty-tip"
};
const _hoisted_67 = {
  key: 2,
  class: "share-modal"
};
const _hoisted_68 = {
  class: "share-modal-content reward-modal"
};
const _hoisted_69 = {
  class: "share-modal-title"
};
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 选择回报档 ");
const _hoisted_71 = {
  class: "reward-select-content"
};
const _hoisted_72 = /*#__PURE__*/_createTextVNode("加载中...");
const _hoisted_73 = ["onClick"];
const _hoisted_74 = {
  class: "reward_info"
};
const _hoisted_75 = ["src"];
const _hoisted_76 = {
  class: "reward_text"
};
const _hoisted_77 = {
  class: "reward_name"
};
const _hoisted_78 = {
  class: "reward_price"
};
const _hoisted_79 = {
  key: 3,
  class: "share-modal"
};
const _hoisted_80 = {
  class: "share-modal-content"
};
const _hoisted_81 = {
  class: "share-modal-title"
};
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 选择开奖时间 ");
const _hoisted_83 = {
  class: "share_reward_content"
};
const _hoisted_84 = {
  class: "name"
};
const _hoisted_85 = {
  class: "tips"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "自定义时间", -1));
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "设置具体开奖时间", -1));
const _hoisted_88 = [_hoisted_86, _hoisted_87];
import { reactive, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { env } from "md-base-tools/env";
import { GoBack, mdToast } from "../../utils/tools";
import { getSubmitableProList, getSubmitableRewardList, createProSubmitableActivity } from "@api";
import ScoreDatePicker from "@@/score/ScoreDatePicker.vue";
export default {
  setup(__props) {
    const router = useRouter();
    const state = reactive({
      isFix: 0,
      showShareModal: false,
      showProSelectModal: false,
      // 项目选择弹窗
      showRewardSelectModal: false,
      // 回报档选择弹窗
      showTimeSelectModal: false,
      // 时间选择弹窗
      showDatePicker: false,
      // 日期时间选择器
      currentReward: null,
      // 当前选择时间的回报档
      loading: false,
      discount_type: 1,
      // 1免单 2折扣立减
      discount_type_list: [{
        name: '免单',
        tips: '用户0元购买商品',
        value: 1
      }, {
        name: '立减折扣',
        tips: '用户至少低于原价9折购买',
        value: 2
      }],
      // 项目相关
      proList: [],
      selectedProId: '',
      selectedProInfo: null,
      // 回报档相关
      rewardsList: [],
      selectedRewards: [],
      // 已选择的回报档列表（多个）
      editingRewardIndex: null // 当前正在编辑的回报档索引，null 表示新增模式
    });

    // 当前选中的优惠类型
    const currentDiscountType = computed(() => {
      return state.discount_type_list.find(item => item.value === state.discount_type) || state.discount_type_list[0];
    });
    function handleGoBack() {
      GoBack();
    }

    // 跳转到规则页面
    function handleGoToRule() {
      router.push({
        path: '/score/score_rule'
      });
    }
    function handleStickyAction(is_fix) {
      state.isFix = is_fix ? 1 : 0;
    }

    // 打开选择玩法弹窗
    function openDiscountTypeModal() {
      state.showShareModal = true;
    }

    // 关闭弹窗
    function closeShareModal() {
      state.showShareModal = false;
    }

    // 选择玩法
    function selectDiscountType(value) {
      state.discount_type = value;
      closeShareModal();
    }

    // 计算剩余天数和相关字段
    const calculateEndTimeInfo = endTime => {
      if (!endTime) {
        return {
          end_str: '',
          init_end_time: ''
        };
      }

      // 解析结束时间
      const endDate = new Date(endTime.replace(/-/g, '/'));
      const currentDate = new Date();

      // 将结束时间减去 72 小时（3天）
      const adjustedEndDate = new Date(endDate.getTime() - 72 * 60 * 60 * 1000);

      // 计算剩余毫秒数（使用调整后的结束时间）
      const diffMs = adjustedEndDate.getTime() - currentDate.getTime();

      // 计算剩余天数（向上取整）
      const remainingDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      let displayDays = 0;
      let end_str = '';
      if (remainingDays >= 22) {
        // 剩余时长 >= 22天，展示22天
        displayDays = 22;
        end_str = '22天';
      } else if (remainingDays > 3) {
        // 3天 < 剩余时长 < 22天，展示具体天数
        displayDays = remainingDays;
        end_str = `${remainingDays}天`;
      } else {
        // 剩余时长 <= 3天
        displayDays = remainingDays > 0 ? remainingDays : 0;
        end_str = displayDays > 0 ? `${displayDays}天` : '';
      }

      // 计算 init_end_time
      // 1. endTime - 3天
      const endTimeMinus3Days = adjustedEndDate.getTime();
      // 2. 当前时间 + 22天
      const currentPlus22Days = currentDate.getTime() + 22 * 24 * 60 * 60 * 1000;
      // 3. 取较小的值
      const candidateTime = Math.min(endTimeMinus3Days, currentPlus22Days);
      // 4. 当前时间 + 1天（最小限制）
      const minTime = currentDate.getTime() + 24 * 60 * 60 * 1000;
      let init_end_time = '';

      // 如果候选时间大于等于最小时间，则使用它；否则返回空
      if (candidateTime >= minTime) {
        const initEndDate = new Date(candidateTime);
        const year = initEndDate.getFullYear();
        const month = String(initEndDate.getMonth() + 1).padStart(2, '0');
        const day = String(initEndDate.getDate()).padStart(2, '0');
        const hours = String(initEndDate.getHours()).padStart(2, '0');
        const minutes = String(initEndDate.getMinutes()).padStart(2, '0');
        const seconds = String(initEndDate.getSeconds()).padStart(2, '0');
        init_end_time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
      return {
        end_str,
        init_end_time
      };
    };

    // 数据格式转换：将回报档数据统一转换为标准格式
    const normalizeRewardData = (rawData, projectInfo) => {
      console.log('normalizeRewardData rawData:', rawData);
      if (!Array.isArray(rawData)) return [];
      const normalized = rawData.map(item => {
        // 使用回报档自己的 end_time 来计算时间信息
        const endTimeInfo = calculateEndTimeInfo((item === null || item === void 0 ? void 0 : item.end_time) || '');

        // 创建基础回报档对象
        return {
          id: (item === null || item === void 0 ? void 0 : item.reward_id) || '',
          title: (item === null || item === void 0 ? void 0 : item.reward_title) || '',
          logo: (item === null || item === void 0 ? void 0 : item.img_url) || '',
          price: (item === null || item === void 0 ? void 0 : item.price) || '0',
          stock: (item === null || item === void 0 ? void 0 : item.stock) || 0,
          end_time: (item === null || item === void 0 ? void 0 : item.end_time) || '',
          is_not_limit_stock: (item === null || item === void 0 ? void 0 : item.is_not_limit_stock) || 0,
          init_stock: 0,
          discount: 9,
          // 默认9折
          time_type: 1,
          // 项目信息
          pro_id: (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.pro_id) || (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.value) || '',
          pro_name: (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.name) || '',
          pro_logo: (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.logo) || '',
          free_coins: (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.free_coins) || 0,
          discount_coins: (projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.discount_coins) || 0,
          // 时间相关字段
          end_str: endTimeInfo.end_str,
          init_end_time: endTimeInfo.init_end_time,
          // 系统计算的默认时间，不可修改
          custom_end_time: endTimeInfo.init_end_time // 用户自定义时间，初始值与 init_end_time 一致
        };
      });
      console.log('normalizeRewardData normalized:', normalized);
      return normalized;
    };

    // 获取项目列表
    const fetchProList = async (autoSelect = false) => {
      try {
        state.loading = true;
        const res = await getSubmitableProList({});
        console.log('fetchProList 返回数据:', res);
        if (!res) {
          console.error('API 返回值为空');
          state.proList = [];
          state.loading = false;
          return;
        }
        const {
          status,
          data,
          message
        } = res;
        if (status == 0) {
          if (Array.isArray(data) && data.length > 0) {
            const newList = [];
            data.forEach(item => {
              if (item) {
                newList.push({
                  value: item.pro_id || '',
                  name: item.title || '',
                  logo: item.img_url || '',
                  pro_id: item.pro_id || '',
                  free_coins: item.free_coins || 0,
                  discount_coins: item.discount_coins || 0
                });
              }
            });
            state.proList = newList;

            // 如果是自动选择模式，且只有一个项目，自动选择它并选择第一个回报档
            if (autoSelect && newList.length === 1) {
              await selectProject(newList[0], true);
            }
          } else {
            state.proList = [];
            mdToast('暂无可选项目');
          }
        } else {
          state.proList = [];
          if (message) {
            mdToast(message);
          }
        }
      } catch (error) {
        console.error('获取项目列表失败:', error);
        mdToast('获取项目列表失败');
        state.proList = [];
      } finally {
        state.loading = false;
      }
    };

    // 获取回报档列表
    const fetchRewardList = async () => {
      if (!state.selectedProId) return;
      try {
        state.loading = true;
        const {
          status,
          data,
          message
        } = await getSubmitableRewardList({
          pro_id: state.selectedProId
        });
        if (status == 0) {
          const rawData = data || [];
          state.rewardsList = normalizeRewardData(rawData, state.selectedProInfo);
        } else {
          state.rewardsList = [];
          if (message) {
            mdToast(message);
          }
        }
      } catch (error) {
        console.error('获取回报档列表失败:', error);
        state.rewardsList = [];
      } finally {
        state.loading = false;
      }
    };

    // 打开项目选择弹窗
    const openProSelectModal = async (editIndex = null) => {
      if (!state.discount_type) {
        mdToast('请选择玩法');
        return;
      }

      // 设置编辑模式：null 表示新增，number 表示编辑指定索引的回报档
      state.editingRewardIndex = editIndex;
      await fetchProList();
      state.showProSelectModal = true;
    };

    // 关闭项目选择弹窗
    const closeProSelectModal = () => {
      state.showProSelectModal = false;
      // 重置编辑索引
      state.editingRewardIndex = null;
    };

    // 选择项目
    const selectProject = async (project, autoSelectFirstReward = false) => {
      state.selectedProId = project.value;
      state.selectedProInfo = project;
      // 只清空当前项目的回报档列表，不清空已选择的回报档
      state.rewardsList = [];

      // 保存编辑索引，因为 closeProSelectModal 会重置它
      const currentEditingIndex = state.editingRewardIndex;
      closeProSelectModal();

      // 恢复编辑索引
      state.editingRewardIndex = currentEditingIndex;

      // 获取该项目的回报档列表
      await fetchRewardList();

      // 如果是编辑模式或自动选择模式
      if (autoSelectFirstReward && state.rewardsList.length > 0) {
        // 自动选择第一个回报档
        selectReward(state.rewardsList[0]);
      } else {
        // 打开回报档选择弹窗（包括编辑模式和新增模式）
        state.showRewardSelectModal = true;
      }
    };

    // 打开回报档选择弹窗（单独调用，用于"继续添加"）
    // const openRewardSelectModal = async () => {
    //     if (!state.selectedProId) {
    //         mdToast('请先选择项目');
    //         return;
    //     }

    //     // 如果回报档列表为空，重新获取
    //     if (state.rewardsList.length === 0) {
    //         await fetchRewardList();
    //     }

    //     state.showRewardSelectModal = true;
    // };

    // 关闭回报档选择弹窗
    const closeRewardSelectModal = () => {
      state.showRewardSelectModal = false;
      // 重置编辑索引
      state.editingRewardIndex = null;
    };

    // 编辑回报档 - 点击"选择项目"
    const editRewardProject = async index => {
      // 打开项目选择弹窗，传入编辑索引
      await openProSelectModal(index);
    };

    // 编辑回报档 - 点击"选择回报档"
    const editRewardItem = async index => {
      const reward = state.selectedRewards[index];
      if (!reward) return;

      // 设置编辑索引
      state.editingRewardIndex = index;

      // 设置项目信息
      state.selectedProId = reward.pro_id;
      state.selectedProInfo = {
        value: reward.pro_id,
        name: reward.pro_name,
        logo: reward.pro_logo,
        pro_id: reward.pro_id,
        free_coins: reward.free_coins,
        discount_coins: reward.discount_coins
      };

      // 获取该项目的回报档列表
      await fetchRewardList();

      // 打开回报档选择弹窗
      state.showRewardSelectModal = true;
    };

    // 选择回报档
    const selectReward = reward => {
      console.log('[Debug] selectReward called with:', reward);
      if (!reward || !reward.id) {
        console.warn('[Debug] selectReward returned early: Invalid reward or missing id', reward);
        return;
      }
      try {
        // 创建回报档的深拷贝，避免引用问题
        const rewardCopy = JSON.parse(JSON.stringify(reward));
        console.log('[Debug] rewardCopy created:', rewardCopy);
        console.log('[Debug] Current editingRewardIndex:', state.editingRewardIndex);
        if (state.editingRewardIndex !== null) {
          // 编辑模式：更新指定索引的回报档
          // 检查是否选择了与其他已选回报档重复的（排除自己）
          const isSelected = state.selectedRewards.some((item, index) => index !== state.editingRewardIndex && item.id === reward.id && item.pro_id === reward.pro_id);
          if (isSelected) {
            mdToast('该回报档已选过');
            return;
          }

          // 保留原有的用户输入数据（库存、折扣等）
          const oldReward = state.selectedRewards[state.editingRewardIndex];
          rewardCopy.init_stock = (oldReward === null || oldReward === void 0 ? void 0 : oldReward.init_stock) || 0;
          rewardCopy.discount = (oldReward === null || oldReward === void 0 ? void 0 : oldReward.discount) || 9;
          rewardCopy.time_type = (oldReward === null || oldReward === void 0 ? void 0 : oldReward.time_type) || 1;
          rewardCopy.custom_end_time = (oldReward === null || oldReward === void 0 ? void 0 : oldReward.custom_end_time) || rewardCopy.custom_end_time;

          // 更新回报档
          state.selectedRewards[state.editingRewardIndex] = rewardCopy;
          console.log('[Debug] Updated reward at index:', state.editingRewardIndex);

          // 重置编辑索引
          state.editingRewardIndex = null;
        } else {
          // 新增模式：检查是否已经选择过
          const isSelected = state.selectedRewards.some(item => item.id === reward.id && item.pro_id === reward.pro_id);
          console.log('[Debug] isSelected check:', isSelected);
          if (isSelected) {
            mdToast('该回报档已选过');
            return;
          }

          // 添加到已选择列表
          state.selectedRewards.push(rewardCopy);
          console.log('[Debug] Added new reward. Total count:', state.selectedRewards.length);
        }

        // 关闭弹窗
        closeRewardSelectModal();
        console.log('[Debug] Modal closed');
      } catch (e) {
        console.error('[Debug] Error in selectReward:', e);
        mdToast('选择回报档出错');
      }
    };

    // 折扣输入格式化 - 限制为两位小数（0.1 ~ 9）
    const formatDiscount = value => {
      // 只保留数字和小数点
      let val = String(value).replace(/[^\d.]/g, '');

      // 防止以小数点开头
      val = val.replace(/^\./g, '');

      // 只保留第一个小数点，去除后续的小数点
      val = val.replace(/\.{2,}/g, '.');
      val = val.replace(/^(\d+)\.(\d*)\.+/, '$1.$2');

      // 分割整数和小数部分
      const parts = val.split('.');

      // 限制整数部分只能是一位（0-9）
      if (parts[0] && parts[0].length > 1) {
        parts[0] = parts[0].charAt(0);
      }

      // 如果整数部分是 9，不允许有小数部分（最大值为 9）
      if (parts[0] === '9' && parts.length > 1) {
        return '9';
      }

      // 限制小数点后最多两位
      if (parts.length > 1 && parts[1].length > 2) {
        parts[1] = parts[1].substring(0, 2);
      }

      // 重新组合
      val = parts.length > 1 ? parts[0] + '.' + parts[1] : parts[0];
      return val;
    };

    // 库存输入格式化 - 限制为正整数（>=1）
    const formatStock = (value, reward) => {
      // 只保留数字
      let val = String(value).replace(/[^\d]/g, '');

      // 移除前导零
      val = val.replace(/^0+/, '');

      // 如果为空，返回空字符串
      if (val === '') {
        return '';
      }

      // 转为数字检查范围
      const numVal = parseInt(val, 10);

      // 如果库存不限，则不限制最大值
      const maxStock = reward.is_not_limit_stock == 1 ? Infinity : reward.stock;

      // 限制范围：最小1，最大为库存上限
      if (numVal < 1) {
        return '1';
      }
      if (numVal > maxStock) {
        return String(maxStock);
      }
      return String(numVal);
    };

    // 打开时间选择弹窗
    const openTimeSelectModal = reward => {
      state.currentReward = reward;
      state.showTimeSelectModal = true;
    };

    // 关闭时间选择弹窗
    const closeTimeSelectModal = () => {
      state.showTimeSelectModal = false;
      state.currentReward = null;
    };

    // 选择时间类型
    const selectTimeType = timeType => {
      if (state.currentReward) {
        state.currentReward.time_type = timeType;
      }
      closeTimeSelectModal();
    };

    // 获取显示的结束时间
    const getDisplayEndTime = reward => {
      if (reward.time_type === 1) {
        // 提报后X天开奖：使用系统计算的 init_end_time
        return reward.init_end_time;
      } else {
        // 自定义时间：使用用户设置的 custom_end_time
        return reward.custom_end_time;
      }
    };

    // 打开自定义时间日期选择器
    const openCustomTimeModal = reward => {
      state.currentReward = reward;
      state.showDatePicker = true;
    };

    // 处理日期确认
    const handleDateConfirm = ({
      datetime
    }) => {
      if (state.currentReward) {
        // 设置用户自定义时间 "YYYY-MM-DD HH:mm:00"
        state.currentReward.custom_end_time = datetime;
        // 如果是自定义时间，设置 time_type 为 2
        if (state.currentReward.time_type !== 2) {
          state.currentReward.time_type = 2;
        }
      }
      state.showDatePicker = false;
    };

    // // 限制数字输入（带小数点）- 参考PC版本逻辑
    // const floatLimitTwo = (val, decimal, max, min) => {
    //     val = String(val || '')
    //         // 提取 数字 & .
    //         .replace(/[^\d.]/g, "")
    //         // 必须是数字开头
    //         .replace(/^[^\d]/g, "")
    //         // 去除多余的点
    //         .replace(/\.(\d?)\.+/g, ".$1")
    //         // 去除整数部分开头多余的零
    //         .replace(/^[0]+(\d+)/g, "$1")
    //         // 保留固定位数的小数
    //         .replace(new RegExp(`^(\\d+\\.\\d{${decimal}}).+`, "g"), "$1");

    //     // 限制整数部分不超过个位数（因为最大值<9）
    //     const parts = val.split('.');
    //     if (parts[0] && parts[0].length > 1) {
    //         val = parts[0].substring(0, 1) + (parts.length > 1 ? '.' + parts[1] : '');
    //     }

    //     if (min && Number(val) <= min) {
    //         val = min;
    //     }

    //     if (max && Number(val) > max) {
    //         // 如果超过最大值，截取掉最后一位
    //         val = val.slice(0, -1);
    //     }

    //     return val;
    // };

    // // 限制整数输入（用于库存）
    // const floatLimit = (val, max, min) => {
    //     // 转为字符串并只保留数字
    //     val = String(val || '')
    //         .replace(/[^\d]/g, "")
    //         // 去除整数部分开头多余的零
    //         .replace(/^0+(\d+)/, "$1");

    //     // 如果为空，返回空字符串
    //     if (val === '') {
    //         return '';
    //     }

    //     // 单独的0是允许的
    //     if (val === '0') {
    //         return '0';
    //     }

    //     // 检查最小值
    //     if (typeof min === 'number' && Number(val) < min) {
    //         val = String(min);
    //     }

    //     // 检查最大值
    //     if (typeof max === 'number' && Number(val) > max) {
    //         val = String(max);
    //     }

    //     return val;
    // };

    // 删除回报档
    const deleteReward = index => {
      // 第一个回报档不允许删除
      if (index === 0) {
        return;
      }
      if (state.selectedRewards.length === 0) return;

      // 删除指定索引的回报档
      state.selectedRewards.splice(index, 1);
    };

    // 处理取消按钮（添加回报档）
    const addNewReward = () => {
      openProSelectModal();
    };

    // 处理确认报名按钮
    const handleSubmit = async () => {
      // 数据验证
      if (!state.discount_type) {
        mdToast('请选择玩法类型');
        return;
      }
      if (state.selectedRewards.length === 0) {
        mdToast('请添加回报档');
        return;
      }

      // 验证每个回报档的必填项
      for (let i = 0; i < state.selectedRewards.length; i++) {
        const item = state.selectedRewards[i];

        // 验证库存
        if (!item.init_stock || Number(item.init_stock) <= 0) {
          mdToast(`回报档${i + 1}请输入活动库存`);
          return;
        }

        // 验证折扣（折扣类型下）
        if (state.discount_type === 2 && (!item.discount || Number(item.discount) <= 0)) {
          mdToast(`回报档${i + 1}请输入优惠折扣`);
          return;
        }

        // 验证开奖时间
        if (state.discount_type === 1) {
          // 免单：必须有自定义时间
          if (!item.custom_end_time) {
            mdToast(`回报档${i + 1}请设置开奖时间`);
            return;
          }
        } else if (state.discount_type === 2) {
          // 折扣：根据 time_type 验证
          if (item.time_type === 2 && !item.custom_end_time) {
            mdToast(`回报档${i + 1}请设置自定义开奖时间`);
            return;
          }
        }
      }

      // 转换为接口要求的数据格式
      const rewardList = state.selectedRewards.map(item => {
        let discountPrice = '0';
        let discount = '0';
        if (state.discount_type === 1) {
          // 免单：活动价格和折扣都为0
          discountPrice = '0';
          discount = '0';
        } else if (state.discount_type === 2) {
          // 折扣：活动价格 = 原价 * (折扣 / 10)
          if (item.discount) {
            discountPrice = (item.price * (item.discount / 10)).toFixed(2);
            discount = String(item.discount);
          }
        }

        // 确定使用哪个时间字段（参考 create.vue 逻辑）
        let endTime = '';
        if (state.discount_type === 1) {
          // 免单：使用 custom_end_time
          endTime = item.custom_end_time || '';
        } else if (state.discount_type === 2) {
          // 折扣：根据 time_type 决定
          if (item.time_type === 1) {
            // 提报后X天开奖：使用 init_end_time
            endTime = item.init_end_time || '';
          } else {
            // 自定义时间：使用 custom_end_time
            endTime = item.custom_end_time || '';
          }
        }
        return {
          reward_id: item.id,
          submit_num: Number(item.init_stock) || 0,
          discount_price: discountPrice,
          end_time: endTime,
          pro_id: item.pro_id,
          discount: discount
        };
      });
      try {
        state.loading = true;

        // 构建请求参数
        const option = {
          discount_type: state.discount_type,
          reward_list: JSON.stringify(rewardList)
        };
        console.log('提交报名参数:', option);

        // 调用 API
        const res = await createProSubmitableActivity(option);
        if (res.status == 0) {
          mdToast('报名成功');
          // 成功后清空数据并返回上一页
          state.selectedRewards = [];
          state.selectedProId = '';
          state.selectedProInfo = null;
          state.rewardsList = [];
          GoBack();
        } else {
          mdToast(res.message || '报名失败');
        }
      } catch (error) {
        console.error('提交报名失败:', error);
        mdToast('提交失败，请重试');
      } finally {
        state.loading = false;
      }
    };

    // 页面初始化
    onMounted(() => {
      // 一进页面就请求项目列表，如果只有一个项目，自动选择它和第一个回报档
      fetchProList(true);
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_loading = _resolveComponent("van-loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!_unref(env).isWeixin() && !_unref(env).isModianAndroid() && !_unref(env).isModianIos() && !_unref(env).isModianIosNew() ? (_openBlock(), _createBlock(_component_van_sticky, {
        key: 0,
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': _unref(state).isFix
          }])
        }, [_createVNode(_component_van_image, {
          class: "back-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_activity/score_back.png', 40),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
        }, null, 8, ["src"]), _hoisted_2], 2)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_3)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("p", {
        class: "rule",
        onClick: _cache[1] || (_cache[1] = $event => handleGoToRule())
      }, "查看规则")]), _createElementVNode("div", {
        class: "discount_type",
        onClick: _cache[2] || (_cache[2] = $event => openDiscountTypeModal())
      }, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(_unref(currentDiscountType).name), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(currentDiscountType).tips), 1)])]), _unref(state).selectedRewards.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _hoisted_12, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[3] || (_cache[3] = $event => openProSelectModal())
      }, "添加回报档")])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).selectedRewards, (reward, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "reward_card",
          key: reward.id
        }, [_createElementVNode("div", {
          class: _normalizeClass(["title", {
            'no-delete': index === 0
          }]),
          onClick: $event => index !== 0 ? deleteReward(index) : null
        }, " 回报档 " + _toDisplayString(index + 1), 11, _hoisted_14), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
          class: "score_item",
          onClick: $event => editRewardProject(index)
        }, [_hoisted_17, _createElementVNode("p", _hoisted_18, _toDisplayString(reward.pro_name), 1)], 8, _hoisted_16), _createElementVNode("div", {
          class: "score_item",
          onClick: $event => editRewardItem(index)
        }, [_hoisted_20, _createElementVNode("p", _hoisted_21, _toDisplayString(reward.title), 1)], 8, _hoisted_19), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("p", null, _toDisplayString(reward.price), 1)]), _unref(state).discount_type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_van_field, {
          modelValue: reward.discount,
          "onUpdate:modelValue": $event => reward.discount = $event,
          placeholder: "0.1 ~ 9",
          type: "text",
          inputmode: "decimal",
          formatter: formatDiscount
        }, null, 8, ["modelValue", "onUpdate:modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("p", _hoisted_29, "¥" + _toDisplayString(_unref(state).discount_type === 1 ? '0' : reward.discount ? (reward.price * (reward.discount / 10)).toFixed(2) : '0'), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createVNode(_component_van_field, {
          modelValue: reward.init_stock,
          "onUpdate:modelValue": $event => reward.init_stock = $event,
          placeholder: "请输入库存数量",
          type: "text",
          inputmode: "numeric",
          formatter: value => formatStock(value, reward)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter"]), reward.stock > 0 && reward.is_not_limit_stock != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_33, "最多" + _toDisplayString(reward.stock), 1)) : _createCommentVNode("", true)])]), _unref(state).discount_type === 1 ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "score_item",
          onClick: $event => openCustomTimeModal(reward)
        }, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createElementVNode("p", null, _toDisplayString(reward.custom_end_time || '请设置开奖时间'), 1)])], 8, _hoisted_34)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createElementVNode("div", {
          class: "score_item",
          onClick: $event => openTimeSelectModal(reward)
        }, [_hoisted_38, _createElementVNode("div", _hoisted_39, [reward.time_type === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_40, "提报后" + _toDisplayString(reward.end_str) + "开奖", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_41, "自定义时间")), reward.time_type === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(getDisplayEndTime(reward) || '未设置') + " 开奖", 1)) : _createCommentVNode("", true)])], 8, _hoisted_37), reward.time_type === 2 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "score_item",
          onClick: $event => openCustomTimeModal(reward)
        }, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("p", null, _toDisplayString(reward.custom_end_time || '请设置自定义时间'), 1)])], 8, _hoisted_43)) : _createCommentVNode("", true)], 64))])]);
      }), 128))])), _unref(state).selectedRewards.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, "发货须知：提报回报档的订单需在对应项目「订单管理」查询，发货在该项目「批量发货」完成；若项目众筹失败，回报档无需准备发货")) : _createCommentVNode("", true), _unref(state).selectedRewards.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", {
        class: "btn",
        onClick: _cache[4] || (_cache[4] = $event => addNewReward())
      }, "添加回报档"), _createElementVNode("div", {
        class: "btn submit",
        onClick: _cache[5] || (_cache[5] = $event => handleSubmit())
      }, "确认报名")])) : _createCommentVNode("", true)])]), _unref(state).showShareModal ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", {
        class: "share-modal-mask",
        onClick: _cache[6] || (_cache[6] = $event => closeShareModal())
      }), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", {
        class: "share-modal-close",
        onClick: _cache[7] || (_cache[7] = $event => closeShareModal())
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/qualificationDistributeIcon.png', 40)
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).discount_type_list, item => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["discount_type_item", {
            active: _unref(state).discount_type === item.value
          }]),
          key: item.value,
          onClick: $event => selectDiscountType(item.value)
        }, [_createElementVNode("div", _hoisted_54, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(item.tips), 1)], 10, _hoisted_53);
      }), 128))])])])) : _createCommentVNode("", true), _unref(state).showProSelectModal ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("div", {
        class: "share-modal-mask",
        onClick: _cache[8] || (_cache[8] = $event => closeProSelectModal())
      }), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", {
        class: "share-modal-close",
        onClick: _cache[9] || (_cache[9] = $event => closeProSelectModal())
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/qualificationDistributeIcon.png', 40)
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_60, [_unref(state).loading ? (_openBlock(), _createBlock(_component_van_loading, {
        key: 0,
        type: "spinner",
        size: "48",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_61]),
        _: 1
      })) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).proList, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "pro_item",
          key: item.value,
          onClick: $event => selectProject(item)
        }, [_createElementVNode("div", _hoisted_63, [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(item.logo, 100),
          class: "pro_logo"
        }, null, 8, _hoisted_64), _createElementVNode("div", _hoisted_65, _toDisplayString(item.name), 1)])], 8, _hoisted_62);
      }), 128)), _unref(state).proList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_66, " 暂无可选项目 ")) : _createCommentVNode("", true)], 64))])])])) : _createCommentVNode("", true), _unref(state).showRewardSelectModal ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("div", {
        class: "share-modal-mask",
        onClick: _cache[10] || (_cache[10] = $event => closeRewardSelectModal())
      }), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", {
        class: "share-modal-close",
        onClick: _cache[11] || (_cache[11] = $event => closeRewardSelectModal())
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/qualificationDistributeIcon.png', 40)
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_71, [_unref(state).loading ? (_openBlock(), _createBlock(_component_van_loading, {
        key: 0,
        type: "spinner",
        size: "48",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_72]),
        _: 1
      })) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_unref(state).rewardsList, reward => {
        return _openBlock(), _createElementBlock("div", {
          class: "reward-item",
          key: reward.id,
          onClick: $event => selectReward(reward)
        }, [_createElementVNode("div", _hoisted_74, [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(reward.logo, 100),
          class: "reward_logo"
        }, null, 8, _hoisted_75), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, _toDisplayString(reward.title), 1), _createElementVNode("div", _hoisted_78, "¥" + _toDisplayString(reward.price), 1)])])], 8, _hoisted_73);
      }), 128))])])])) : _createCommentVNode("", true), _unref(state).showTimeSelectModal ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_createElementVNode("div", {
        class: "share-modal-mask",
        onClick: _cache[12] || (_cache[12] = $event => closeTimeSelectModal())
      }), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_hoisted_82, _createElementVNode("div", {
        class: "share-modal-close",
        onClick: _cache[13] || (_cache[13] = $event => closeTimeSelectModal())
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/qualificationDistributeIcon.png', 40)
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", {
        class: _normalizeClass(["time_type_item", {
          active: _unref(state).currentReward && _unref(state).currentReward.time_type === 1
        }]),
        onClick: _cache[14] || (_cache[14] = $event => selectTimeType(1))
      }, [_createElementVNode("div", _hoisted_84, "提报后" + _toDisplayString(_unref(state).currentReward ? _unref(state).currentReward.end_str : '') + "开奖", 1), _createElementVNode("div", _hoisted_85, _toDisplayString(_unref(state).currentReward ? _unref(state).currentReward.init_end_time : ''), 1)], 2), _createElementVNode("div", {
        class: _normalizeClass(["time_type_item", {
          active: _unref(state).currentReward && _unref(state).currentReward.time_type === 2
        }]),
        onClick: _cache[15] || (_cache[15] = $event => selectTimeType(2))
      }, _hoisted_88, 2)])])])) : _createCommentVNode("", true), _createVNode(ScoreDatePicker, {
        show: _unref(state).showDatePicker,
        "onUpdate:show": _cache[16] || (_cache[16] = $event => _unref(state).showDatePicker = $event),
        end_date: _unref(state).currentReward ? _unref(state).currentReward.end_time : '',
        onConformDate: handleDateConfirm
      }, null, 8, ["show", "end_date"])], 64);
    };
  }
};